import { features } from '@kdcloudjs/table';

function mergeCellHover(pipeline) {
  pipeline.use(features.mergeCellHover());
}

export default mergeCellHover;